import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface RedirectProps {
  readonly path: string;
}

function Redirect({ path }: RedirectProps) {
  const navigate = useNavigate();

  useEffect(() => {
    return navigate(path);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

export { Redirect as RedirectNavigation };
